import type { UseVoiceSessionResult } from "@voice/use-voice-session";
import { createContext, useContext } from "react";

export const VoiceSessionContext = createContext<UseVoiceSessionResult | null>(
  null,
);

export const useVoice = (): UseVoiceSessionResult => {
  const ctx = useContext(VoiceSessionContext);
  if (!ctx)
    throw new Error("useVoice must be used within VoiceSessionProvider");
  return ctx;
};
